import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=6d4fd0d8&scoped=true&"
import script from "./Proposal.vue?vue&type=script&lang=js&"
export * from "./Proposal.vue?vue&type=script&lang=js&"
import style0 from "./css/Proposal.scss?vue&type=style&index=0&id=6d4fd0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4fd0d8",
  null
  
)

export default component.exports